import { render, staticRenderFns } from "./Karir.vue?vue&type=template&id=5620f0f1&"
import script from "./Karir.vue?vue&type=script&lang=js&"
export * from "./Karir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports